module.exports = __webpack_public_path__ + "img/0.93cf8840.png";